import React from 'react';
import classNames from 'classnames';

import css from './Icons.module.css';

const IconShopsAndDeliveryBoxes = props => {
  const { className } = props;
  const classes = classNames(className, css.smallIcon);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 48 48"
    >
      <g fill="#010002">
        <path d="M47 46h-2V22.2c1.6-.9 2.7-2.7 2.9-4.7.1-.2.2-.3.2-.5s0-.3-.1-.5L43 .7c-.2-.4-.6-.7-1-.7H6c-.5 0-.9.3-1 .7l-5 16V17c0 2.3 1.2 4.3 3 5.3V46H1c-.6 0-1 .4-1 1s.4 1 1 1h46c.6 0 1-.4 1-1s-.5-1-1-1zM6.7 2h34.6l4.4 14H2.3L6.7 2zm29.9 16c-.4 1.7-1.8 3-3.5 3s-3.1-1.3-3.5-3h7zm-9.2 0c-.4 1.7-1.8 3-3.5 3s-3.1-1.3-3.5-3h7zm-9.2 0c-.4 1.7-1.8 3-3.5 3s-3.1-1.3-3.5-3h7zM2.1 18H9c-.4 1.7-1.8 3-3.5 3s-3-1.3-3.4-3zm17.7 28h-10V29.7h10V46zM43 46H21.8V28.7c0-.6-.4-1-1-1h-12c-.6 0-1 .4-1 1V46H5V23h.6c1.9 0 3.6-1 4.6-2.6 1 1.6 2.7 2.6 4.6 2.6 1.9 0 3.6-1 4.6-2.6 1 1.6 2.7 2.6 4.6 2.6 1.9 0 3.6-1 4.6-2.6 1 1.6 2.7 2.6 4.6 2.6 1.9 0 3.6-1 4.6-2.6 1 1.6 2.7 2.6 4.6 2.6.2 0 .5 0 .7-.1V46zm-.7-25c-1.7 0-3.1-1.3-3.5-3h6.9c-.4 1.7-1.8 3-3.4 3z" />
        <path d="M40.3 27.6H25.2c-.6 0-1 .4-1 1v10.8c0 .6.4 1 1 1h15.1c.6 0 1-.4 1-1V28.6c0-.6-.5-1-1-1zm-1 10.8H26.2v-8.8h13.1v8.8z" />
      </g>
    </svg>
  );
};

export default IconShopsAndDeliveryBoxes;
